export const DIALOG_ACTIONS_ENUM = {
  'EDIT': 'edit',
  'DELETE': 'delete',
  'NONE': ''
}

export const ALERT_SEVERITY_ENUM = {
  'ERROR': 'error',
  'WARNING': 'warning',
  'INFO': 'info',
  'SUCCESS': 'success' 
}